// extracted by mini-css-extract-plugin
export default {"container":"FormLabel_container__bAFVK","label":"FormLabel_label__6D7om","optional":"FormLabel_optional__SQDxG","fieldset":"FormLabel_fieldset__8UFhN"};